import React from 'react';
import './Skeleton.css';

const Skeleton = ({ count = 12 }) => {
  const skeletons = new Array(count).fill(null); // Array of 12 skeletons


  return (

    <div className="skeleton--main__export--teeshirts--item">
      <div className="skeleton--main__export--teeshirts--text">
        <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-text"></div>
      </div>
      <div className="skeleton--main__export--teeshirts--img">
        <div className="skeleton skeleton-img"></div>
      </div>
    </div>

  );


  // return (
  //   <div className="skeleton-container">
  //     {skeletons.map((_, index) => (
  //       <div key={index} className="skeleton--main__export--teeshirts--item">
  //         <div className="skeleton--main__export--teeshirts--text">
  //           <div className="skeleton skeleton-title"></div>
  //           <div className="skeleton skeleton-text"></div>
  //         </div>
  //         <div className="skeleton--main__export--teeshirts--img">
  //           <div className="skeleton skeleton-img"></div>
  //         </div>
  //       </div>
  //     ))}
  //   </div>
  // );
};

export default Skeleton;
